import { render } from "./SearchScore.vue?vue&type=template&id=95f60dde&scoped=true"
import script from "./SearchScore.vue?vue&type=script&lang=js"
export * from "./SearchScore.vue?vue&type=script&lang=js"

import "./SearchScore.vue?vue&type=style&index=0&id=95f60dde&scoped=true&lang=css"

import exportComponent from "C:\\projeto\\dynamik\\dynamik_webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95f60dde"]])

export default __exports__